export enum SsnBlockEndIndex {
  First = 3,
  Second = 5,
  Last = 9,
}
